import {
  INCIDENT_FORM_LIST,
  INCIDENT_FORM_LIST_FAIL,
  INCIDENT_FORM_LIST_SUCCESS,
  UPLOAD_INCIDENT_FORM,
  UPLOAD_INCIDENT_FORM_SUCCESS,
  UPLOAD_INCIDENT_FORM_FAIL,
  UPDATE_INCIDENT_FORM,
  UPDATE_INCIDENT_FORM_SUCCESS,
  UPDATE_INCIDENT_FORM_FAIL,
  GET_ADDED_QUESTIONS,
  GET_ADDED_QUESTIONS_SUCCESS,
  GET_ADDED_QUESTIONS_FAIL,
  DELETE_INCIDENT_QUESTION,
  DELETE_INCIDENT_QUESTION_SUCCESS,
  DELETE_INCIDENT_QUESTION_FAIL,
  UPDATE_INCIDENT_FORM_QUES,
  UPDATE_INCIDENT_FORM_QUES_SUCCESS,
  UPDATE_INCIDENT_FORM_QUES_FAIL,
  EDIT_INICIDENT_FORM_ADMIN,
  EDIT_INICIDENT_FORM_ADMIN_SUCCESS,
  EDIT_INICIDENT_FORM_ADMIN_FAIL,
  SUBMIT_ADMIN_REVIEWD_FORM,
  SUBMIT_ADMIN_REVIEWD_FORM_SUCCESS,
  SUBMIT_ADMIN_REVIEWD_FORM_FAIL,
  GET_ALL_INCIDENT_FORM_DATA,
  GET_ALL_INCIDENT_FORM_DATA_SUCCESS,
  GET_ALL_INCIDENT_FORM_DATA_FAIL,
  GET_OLD_INCIDENT_FORMS,
  GET_OLD_INCIDENT_FORMS_SUCCESS,
  GET_OLD_INCIDENT_FORMS_FAIL,
  SEND_MAIL,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_FAIL,
  INCIDENT_LOGS,
  INCIDENT_LOGS_SUCCESS,
  INCIDENT_LOGS_FAIL,
  ARRANGE_INICIDENT_QUES_ORDER,
  ARRANGE_INICIDENT_QUES_ORDER_SUCCESS,
  ARRANGE_INICIDENT_QUES_ORDER_FAIL,
} from "./actionTypes";

export const arrangeIndicentQuesOrder = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ARRANGE_INICIDENT_QUES_ORDER,
  payload: { data, onSuccess, onError },
});
export const arrangeIndicentQuesOrderSuccess = (data = {}) => ({
  type: ARRANGE_INICIDENT_QUES_ORDER_SUCCESS,
  payload: data,
});
export const arrangeIndicentQuesOrderFail = (data = {}) => ({
  type: ARRANGE_INICIDENT_QUES_ORDER_FAIL,
  payload: data,
});

export const sendMailForIncident = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SEND_MAIL,
  payload: { data, onSuccess, onError },
});
export const sendMailForIncidentSuccess = (data = {}) => ({
  type: SEND_MAIL_SUCCESS,
  payload: data,
});
export const sendMailForIncidentFail = (data = {}) => ({
  type: SEND_MAIL_FAIL,
  payload: data,
});

export const getOldIncidentForms = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_OLD_INCIDENT_FORMS,
  payload: data,
});
export const getOldIncidentFormsSuccess = (data = {}) => ({
  type: GET_OLD_INCIDENT_FORMS_SUCCESS,
  payload: data,
});
export const getOldIncidentFormsFail = (data = {}) => ({
  type: GET_OLD_INCIDENT_FORMS_FAIL,
  payload: data,
});

export const getAllIncidentFormData = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ALL_INCIDENT_FORM_DATA,
  payload: data,
});
export const getAllIncidentFormDataSuccess = (data = {}) => ({
  type: GET_ALL_INCIDENT_FORM_DATA_SUCCESS,
  payload: data,
});
export const getAllIncidentFormDataFail = (data = {}) => ({
  type: GET_ALL_INCIDENT_FORM_DATA_FAIL,
  payload: data,
});

export const submitAdminReviewedForm = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SUBMIT_ADMIN_REVIEWD_FORM,
  payload: { data, onSuccess, onError },
});
export const submitAdminReviewedFormSuccess = (data = {}) => ({
  type: SUBMIT_ADMIN_REVIEWD_FORM_SUCCESS,
  payload: data,
});
export const submitAdminReviewedFormFail = (data = {}) => ({
  type: SUBMIT_ADMIN_REVIEWD_FORM_FAIL,
  payload: data,
});

export const editIncidentFormAdmin = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: EDIT_INICIDENT_FORM_ADMIN,
  payload: { data, onSuccess, onError },
});

export const editIncidentFormAdminSuccess = (data = {}) => ({
  type: EDIT_INICIDENT_FORM_ADMIN_SUCCESS,
  payload: data,
});
export const editIncidentFormAdminFail = (data = {}) => ({
  type: EDIT_INICIDENT_FORM_ADMIN_FAIL,
  payload: data,
});

export const updateIncidentFormQues = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_INCIDENT_FORM_QUES,
  payload: { data, onSuccess, onError },
});
export const updateIncidentFormQuesSuccess = (data = {}) => ({
  type: UPDATE_INCIDENT_FORM_QUES_SUCCESS,
  payload: data,
});
export const updateIncidentFormQuesFail = (data = {}) => ({
  type: UPDATE_INCIDENT_FORM_QUES_FAIL,
  payload: data,
});

export const deleteIncidentQues = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_INCIDENT_QUESTION,
  payload: { data, onError, onSuccess },
});
export const deleteIncidentQuesSuccess = (data = {}) => ({
  type: DELETE_INCIDENT_QUESTION_SUCCESS,
  payload: data,
});
export const deleteIncidentQuesFail = (data = {}) => ({
  type: DELETE_INCIDENT_QUESTION_FAIL,
  payload: data,
});

export const getAddedQuestions = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ADDED_QUESTIONS,
  payload: data,
});
export const getAddedQuestionsSuccess = (data = {}) => ({
  type: GET_ADDED_QUESTIONS_SUCCESS,
  payload: data,
});
export const getAddedQuestionsFail = (data = {}) => ({
  type: GET_ADDED_QUESTIONS_FAIL,
  payload: data,
});

// action to add new question in incident form (old fucntion)
export const updateIncidentForm = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_INCIDENT_FORM,
  payload: { data, onSuccess, onError },
});
export const updateIncidentFormSuccess = (data = {}) => ({
  type: UPDATE_INCIDENT_FORM_SUCCESS,
  payload: data,
});
export const updateIncidentFormFail = (data = {}) => ({
  type: UPDATE_INCIDENT_FORM_FAIL,
  payload: data,
});

export const uploadIncidentForm = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPLOAD_INCIDENT_FORM,
  payload: data,
});
export const uploadIncidentFormSuccess = (data = {}) => ({
  type: UPLOAD_INCIDENT_FORM_SUCCESS,
  payload: data,
});
export const uploadIncidentFormFail = (data = {}) => ({
  type: UPLOAD_INCIDENT_FORM_FAIL,
  payload: data,
});

export const getIncidentList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: INCIDENT_FORM_LIST,
  payload: data,
});
export const getIncidentListSuccess = (data = {}) => ({
  type: INCIDENT_FORM_LIST_SUCCESS,
  payload: data,
});
export const getIncidentListFail = (data = {}) => ({
  type: INCIDENT_FORM_LIST_FAIL,
  payload: data,
});

export const incidentLogs = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: INCIDENT_LOGS,
  payload: { data, onSuccess, onError },
});
export const incidentLogsSuccess = (data = {}) => ({
  type: INCIDENT_LOGS_SUCCESS,
  payload: data,
});
export const incidentLogsFail = (data = {}) => ({
  type: INCIDENT_LOGS_FAIL,
  payload: data,
});
